import { useState } from "react";
import * as React from "react";

export default function MultiSelect({  options, selected, onChange, error,optionLabel,optionValue }) {
  const [open, setOpen] = useState(false);


const handleToggle = (option) => {
  let newSelected = [...selected];

  // check if option is already in selected (by id)
  const exists = newSelected.some(o => o.value === option[optionValue]);

  if (exists) {
    // remove it
    newSelected = newSelected.filter(o => o.value !== option[optionValue]);
  } else {
    // add it
    newSelected.push({value:option[optionValue],label:option[optionLabel]});
  }

  onChange(newSelected);
};


  return (
    <div style={{ position: "relative",width:"100%" }}>
     
      {/* Dropdown button */}
      <div
        onClick={() => setOpen(!open)}
        style={{
          border: `1px solid ${error ? "#EF4444" : "#E5E7EB"}`,
          borderRadius: "4px",
          padding: "10px 12px",
          cursor: "pointer",
          background: "#fff",
        }}
      >
      {selected.length > 0 ? (
      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
        {selected.map(opt => (
          <span
            key={opt.value}
            style={{
              background: "#F3F4F6",
              borderRadius: "12px",
              padding: "2px 8px",
              fontSize: "14px",
              color: "#374151"
            }}
          >
            {opt.label}
          </span>
        ))}
      </div>
      ) : (
      "Select..."
      )}
      </div>

      {/* Dropdown list */}
      {open && (
        <div
          style={{
            position: "absolute",
            zIndex: 10,
            width: "100%",
            border: "1px solid #E5E7EB",
            borderRadius: "4px",
            background: "#fff",
            maxHeight: "150px",
            overflowY: "auto",
            marginTop: "4px",
          }}
        >
          {options.map(opt => (
            <label
              key={opt[optionValue]}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "6px 12px",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              <input
                type="checkbox"
                checked={selected.some(o => o.value === opt[optionValue])}
                onChange={() => handleToggle(opt)}
                style={{ marginRight: "8px" }}
              />
              {opt[optionLabel]}
            </label>
          ))}
        </div>
      )}

      {error && (
        <span
          style={{
            color: "#EF4444",
            fontSize: "12px",
            marginTop: "4px",
            display: "block",
          }}
        >
          {error}
        </span>
      )}
    </div>
  );
}
